import { useContext, useEffect, useState, useCallback } from "react";
import { Formik, Form, ErrorMessage } from "formik"
import * as Yup from 'yup';
import { EditableContext } from "common/EditableContextProvider";
import { Select } from "antd";

export const FormComponent = () => {
    const { context } = useContext(EditableContext);
    const { FormBase, resources } = context;
    const [isLoading, setIsLoading] = useState(false);
    const [initialValues, setInitialValues] = useState({});
    const defaultItem = {
        id: 0,
        name: "",
        contacts: [],
    }

    useEffect(() => {
        setInitialValues(getInitialValues());
    }, [context.editID]);

    const getInitialValues = useCallback(
        () => {
            let it = context.getItemSelected();
            if (!it) { it = defaultItem; }
            else { it = { ...it }; }
            return it;
        }, [context.editID]);

    const validateSchema = Yup.object({
        name: Yup.string()
            .required('El campo es obligatorio'),
        contacts: Yup.array()
            .required('El campo es obligatorio'),
    });

    const handleSubmit = async (values, formik) => {
        try {
            setIsLoading(true);
            let id = await context.saveItem(values);
            if (id) {
                formik.setFieldValue('id', id);
                setInitialValues(prev => ({...prev, ...values, id: id}));
            } else { setInitialValues(prev => ({...prev, ...values})); }
        } catch (error) {
            const { errors } = error.response.data;
            let keys = Object.keys(errors);
            keys.forEach((key) => {
                formik.setFieldError(key, errors[key][0]);
            });
        }
        finally { setIsLoading(false); }
    }

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validateSchema}
            enableReinitialize={true}
        >
            {
                (formik) => (
                    <Form>
                        <fieldset disabled={FormBase.isLoading}>
                            <div className="mb-2">
                                <FormBase.FormTextField formik={formik} label="Nombre" id="name" required={true} />
                            </div>
                            <div className="mb-2">
                                <label htmlFor="contacts"></label>
                                <Select
                                    mode="multiple"
                                    allowClear
                                    placeholder="Seleccionar..."
                                    id="contacts" className="w-100"
                                    options={resources.contacts?.map(cnt => ({
                                        value: cnt.id,
                                        label: `${cnt.name} (${cnt.number})`
                                    }))}
                                    value={formik.values.contacts}
                                    onChange={(values) => formik.setFieldValue('contacts', values)}
                                ></Select>
                            </div>
                            <div className="mb-2">
                                <div className="row">
                                    <div className="col">
                                        <button type="button" className="btn btn-sm btn-danger w-100"
                                            onClick={() => context.modalBase.close()}
                                        >
                                            Cancelar
                                        </button>
                                    </div>
                                    <div className="col">
                                        <button type="submit" className="btn btn-sm btn-dark w-100"
                                            disabled={isLoading || !formik.dirty}
                                        >
                                            {isLoading ? "Guardando..." : "Guardar"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </Form>
                )
            }

        </Formik>
    )

}
